import React from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';

import { Typography, Button } from 'antd';

import { openInNewTab } from '@/helpers';
import styled, { StyledProp, css } from '@/styled';

const HelperCenter: React.FC<StyledProp> = ({ className }) => {
  return (
    <div className={className}>
      <Typography.Title level={4} ellipsis>
        Central de ajuda
      </Typography.Title>
      <Typography.Text className='title'>Não achou o que precisa? Acesse nossa Central de Ajuda!</Typography.Text>
      <Button
        type='ghost'
        className='helpButton'
        onClick={() => openInNewTab('https://ajuda.eduzz.com/?article-category=nutror')}
      >
        <Typography.Paragraph>Central de ajuda</Typography.Paragraph>
        <BoxArrowUpRight />
      </Button>
    </div>
  );
};

export default styled(HelperCenter)(
  ({ theme }) => css`
    .title {
      display: block;
      color: ${theme.colorTextTertiary};
      margin-bottom: ${theme.space.pxToRem(24)};
    }

    .helpButton {
      background: ${theme.variables.bgElevated};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${theme.space.pxToRem(8)};
      height: 40px;
      border: 1px solid ${theme.variables.bgComponentsContainer};
      div {
        margin: 0;
      }
    }
  `
);
